<script>
import {
  monCompteCommandeOverviewProps,
  useMonCompteCommandeOverview
} from "./mixin";
import Card from "@/components/molecules/card";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import Divider from "@/components/atoms/divider";
import IconShipping from "@/components/molecules/icon-shipping";
import BadgeStatus from "@/components/molecules/badge-status";
import CommanderANouveau from "@/containers/commander-a-nouveau";
import Popin from "@/components/molecules/popin";

export default {
  name: "CommandeOverview",
  components: {
    Card,
    Divider,
    Button,
    ButtonIcon,
    IconShipping,
    BadgeStatus,
    CommanderANouveau,
    Popin
  },
  props: {
    ...monCompteCommandeOverviewProps()
  },
  setup(props) {
    const { badgeVariant, isLDD } = useMonCompteCommandeOverview(props);
    return { badgeVariant, isLDD };
  }
};
</script>

<template>
  <Card
    class="u-p-sm"
    radius="lg"
    elevation="sm"
  >
    <Popin
      ref="commanderANouveau"
      aria-label="Commander à nouveau"
      size="lg"
    >
      <CommanderANouveau
        :commande="commande"
        class="u-pb-lg"
        @addAllToCart="$refs.commanderANouveau.hide()"
      />
    </Popin>
    <div class="c-command-overview u-flex u-flex-justify-between u-flex-justify-start@md u-flex-align-center u-flex-wrap@md">
      <p class="c-command-overview__date u-font-15 u-full-width@md u-mb-sm@xs u-pr-md u-pr-sm@lg u-pr-none@md">
        {{ dateCommande(commande.attributes.date_commande) }}
      </p>
      <Divider
        vertical
        dotted
        size="sm"
        class="u-none@md"
      />

      <p class="c-command-overview__number u-text-ellipsis u-font-15 u-full-width@md u-mb-sm@md u-pr-md u-pr-sm@lg u-pr-none@md u-pl-md u-pl-sm@lg u-pl-none@md">
        <strong>
          {{ commande.attributes.code }}
        </strong>
        <template v-if="commande.attributes.titre">
          <br />
          {{ truncate(commande.attributes.titre, 28) }}
        </template>
      </p>
      <Divider
        vertical
        dotted
        size="sm"
        class="u-none@md"
      />
      <div class="c-command-overview__shipping u-flex u-flex-align-center u-font-15 u-full-width@md u-mb-sm@md u-pr-md u-pr-sm@lg u-pr-none@md u-pl-md u-pl-sm@lg u-pl-none@md">
        <IconShipping
          :type="commande.attributes.code_type_commande"
          variant="primary"
          size="sm"
        >
          {{ commande.attributes.type_commande }}
          <template v-if="isLDD">
            <br />
            Exclu Web
          </template>
        </IconShipping>
      </div>
      <Divider
        vertical
        dotted
        size="sm"
        class="u-none@md"
      />
      <div class="c-command-overview__status u-flex u-flex-align-center u-full-width@md u-mb-sm@md u-pr-md u-pr-sm@lg u-pr-none@md u-pl-md u-pl-sm@lg u-pl-none@md">
        <BadgeStatus
          size="xs"
          :status="badgeVariant"
          class="u-font-15"
        >
          {{ commande.attributes.statut }}
        </BadgeStatus>
      </div>
      <Divider
        vertical
        dotted
        size="sm"
        class="u-none@md"
      />
      <p class="c-command-overview__amount u-text-right u-font-15 u-full-width@md u-pl-md u-pl-sm@lg u-pl-none@md">
        <strong class="u-font-500">
          {{ formatPrix(commande.attributes.montant_total_ttc) }}&nbsp;€
        </strong>
      </p>
    </div>

    <Divider />

    <div class="u-flex u-flex-align-center u-flex-justify-end">
      <div class="u-pr-lg">
        <Button
          link
          variant="text-light"
          :to="
            `/mon-compte/mes-commandes/${commande.id}?archive=${commande.attributes.is_archive}`
          "
        >
          Voir le détail
        </Button>
      </div>
      <ButtonIcon
        v-if="commande.attributes.is_archive === '0'"
        icon-name="cart"
        icon-color="secondary"
        icon-color-hover="secondary-dark"
        icon-size="xs"
        radius="full"
        variant="secondary"
        link
        :disabled="commande.attributes.nb_articles === 0"
        @click="$refs.commanderANouveau.show()"
      >
        Commander à nouveau
      </ButtonIcon>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
.c-command-overview__date {
  @include mq(0, bp(md)) {
    width: 12rem;
    flex-shrink: none;
  }
}
.c-command-overview__number {
  @include mq(0, bp(md)) {
    width: 30%;
  }
}
.c-command-overview__shipping {
  @include mq(0, bp(md)) {
    width: 30%;
  }
}
.c-command-overview__status {
  @include mq(0, bp(md)) {
    width: 20%;
  }
}
.c-command-overview__amount {
  @include mq(0, bp(md)) {
    width: 10%;
  }
}
</style>
